import React, { useEffect, useState } from 'react';
import StationBatchDetailsModal from './StationBatchDetailsModal';

function StationBatchModal({ station, position, onClose, isTooltip = false, batchData = [] }) {
  const [filteredData, setFilteredData] = useState({
    onSpec: 0,
    needsAttention: 0,
    opportunity: 0,
    total: 0,
    onSpecGroups: 0,
    needsAttentionGroups: 0,
    opportunityGroups: 0,
    totalGroups: 0
  });
  const [showDetails, setShowDetails] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);

  useEffect(() => {
    if (!station) {
      return;
    }

    let onSpec = 0;
    let needsAttention = 0;
    let opportunity = 0;

    // Sets to track unique groupids for each status
    const onSpecGroups = new Set();
    const needsAttentionGroups = new Set();
    const opportunityGroups = new Set();

    // Filter batches where station name includes the Location value
    batchData.forEach((batch) => {
      const location = batch.Location ? String(batch.Location).split(/-/)[0] : '';
      const status = batch.Status;
      const groupId = batch.groupid;
      const stationNameToUse = station.shortName || station.name;

      // Check if station name includes the Location value
      if (
        (stationNameToUse.toLowerCase().includes(location.toLowerCase()) ||
          location.toLowerCase().includes(stationNameToUse.toLowerCase())) &&
        location !== ''
      ) {
        if (status === 'On Specification') {
          onSpec++;
          if (groupId) {
            onSpecGroups.add(groupId);
          }
        } else if (status === 'Needs Attention') {
          needsAttention++;
          if (groupId) {
            needsAttentionGroups.add(groupId);
          }
        } else if (status === 'Opportunity') {
          opportunity++;
          if (groupId) {
            opportunityGroups.add(groupId);
          }
        }
      }
    });

    // Combine all unique groups for total
    const allGroups = new Set([...onSpecGroups, ...needsAttentionGroups, ...opportunityGroups]);

    setFilteredData({
      onSpec,
      needsAttention,
      opportunity,
      total: onSpec + needsAttention + opportunity,
      onSpecGroups: onSpecGroups.size,
      needsAttentionGroups: needsAttentionGroups.size,
      opportunityGroups: opportunityGroups.size,
      totalGroups: allGroups.size
    });
  }, [station, batchData]);

  if (!station) return null;

  const handleViewClick = (status) => {
    if (!isTooltip) {
      setSelectedStatus(status);
      setShowDetails(true);
    }
  };

  const handleBackFromDetails = () => {
    setShowDetails(false);
    setSelectedStatus(null);
  };

  // If showing details, render the details modal instead
  if (showDetails && !isTooltip) {
    return (
      <StationBatchDetailsModal
        station={station}
        statusFilter={selectedStatus}
        batchData={batchData}
        onClose={onClose}
        onBack={handleBackFromDetails}
      />
    );
  }

  const modalStyle = isTooltip
    ? {
        position: 'fixed',
        left: position.x,
        top: position.y,
        transform: 'translate(-50%, calc(-100% - 10px))',
        zIndex: 1001,
        pointerEvents: 'none'
      }
    : {
        position: 'fixed',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1001
      };

  return (
    <>
      {!isTooltip && (
        <div
          className="modal-backdrop"
          onClick={onClose}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1000
          }}
        />
      )}
      <div className="station-batch-modal" style={modalStyle}>
        <div className="modal-header">
          <h3>{station.name}</h3>
          {!isTooltip && (
            <button className="close-button" onClick={onClose}>
              ×
            </button>
          )}
        </div>
        <div className="modal-body">
          <table className="batch-table">
            <thead>
              <tr>
                <th>Status</th>
                <th>Batches</th>
                <th>Groups</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr className="row-on-spec">
                <td className="label-cell">On specification</td>
                <td className="count-cell">{filteredData.onSpec}</td>
                <td className="count-cell">{filteredData.onSpecGroups}</td>
                <td className="action-cell">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleViewClick('On Specification');
                    }}
                  >
                    Click to view
                  </a>
                </td>
              </tr>
              <tr className="row-needs-attention">
                <td className="label-cell">Needs attention</td>
                <td className="count-cell">{filteredData.needsAttention}</td>
                <td className="count-cell">{filteredData.needsAttentionGroups}</td>
                <td className="action-cell">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleViewClick('Needs Attention');
                    }}
                  >
                    Click to view
                  </a>
                </td>
              </tr>
              <tr className="row-opportunity">
                <td className="label-cell">Opportunity</td>
                <td className="count-cell">{filteredData.opportunity}</td>
                <td className="count-cell">{filteredData.opportunityGroups}</td>
                <td className="action-cell">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleViewClick('Opportunity');
                    }}
                  >
                    Click to view
                  </a>
                </td>
              </tr>
              <tr className="row-total">
                <td className="label-cell">Dashboard, All Batches</td>
                <td className="count-cell">{filteredData.total}</td>
                <td className="count-cell">{filteredData.totalGroups}</td>
                <td className="action-cell">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleViewClick('all');
                    }}
                  >
                    Click to view
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default StationBatchModal;
